import { createContext } from 'react';
import { ProjectNewsMeta } from '../reducers/projectNews';
import {
  ProjectNewsCategoryKey,
  ProjectNewsCounts,
  ProjectNewsDto,
} from '../../../models/Project';

export interface ProjectNewsContextProps {
  projectNewsMeta: ProjectNewsMeta;
  projectNewsCountsMeta: ProjectNewsMeta;
  getProjectNewsByProjectId: (
    projectId: string
  ) => ProjectNewsCategoryKey | undefined;
  getProjectNewsDto: (
    projectId: string,
    projectNewsCategoryKey: string
  ) => ProjectNewsDto[];
  getProjectNewsCountsByProjectId: (
    projectId: string
  ) => ProjectNewsCounts | undefined;
  getProjectIdsWithNews: () => string[];
}

const defaultProjectNewsContext: ProjectNewsContextProps = {
  projectNewsMeta: {
    isFetching: false,
    hasError: false,
  },
  projectNewsCountsMeta: {
    isFetching: false,
    hasError: false,
  },
  getProjectNewsByProjectId: () => undefined,
  getProjectNewsDto: () => [],
  getProjectNewsCountsByProjectId: () => undefined,
  getProjectIdsWithNews: () => [],
};

const ProjectNewsContext = createContext<ProjectNewsContextProps>(
  defaultProjectNewsContext
);

export default ProjectNewsContext;
